import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IncidenciasRoutingModule } from "./incidencias-routing.module";
import { IncidenciasComponent } from "./incidencias.component";
import { BotonToggleModule } from "../../../components/boton/boton-toggle.module";
import { MaterialModule } from "../../../components/material/material.module";
import { IncidenciaModule } from "../../../forms/incidencias/incidencia.module";
import { NgxPermissionsModule } from "ngx-permissions";
import { TipoIncidenciaModule } from "../../../forms/incidencias/tipos-incidencia/tipo-incidencia.module";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        IncidenciasRoutingModule,
        IncidenciaModule,
        TipoIncidenciaModule,
        BotonToggleModule,
        MaterialModule,
    ],
    declarations: [
        IncidenciasComponent,
    ],
    providers: [
    ],
    entryComponents: [
    ]
})
export class IncidenciasModule { }